import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_40: FaireProductEntity = {
  token: "catalog_prod_prod-40",
  type: "product",
  name: "Tabletop Accessory - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 76.85,
  msrpDollars: 192.13,
  sku: "PA0040",
  caseSize: 12,
  material: "Metal",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 354,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_stickers-pins"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
